

























































import Vue from "vue";
import moment from "moment";

// Vue Components
import BranchReportFiltersCard from "./BranchReportFiltersCard.vue";
import BranchReportMainSection from "./BranchReportMainSection.vue";
import FrontBackComparisonDetailsCard from "./FrontBackComparisonDetailsCard.vue";

// Model
import { GetBranchReportCommand } from "@/model/communication/branchReport/GetBranchReportCommand";
import { GetBranchReportReqData } from "@/model/communication/branchReport/GetBranchReportReqData";
import { GetBranchReportResData } from "@/model/communication/branchReport/GetBranchReportResData";
import { GetFrontBackComparisonCommand } from "@/model/communication/branchReport/GetFrontBackComparisonCommand";
import { GetFrontBackComparisonReqData } from "@/model/communication/branchReport/GetFrontBackComparisonReqData";
import { GetFrontBackComparisonResData } from "@/model/communication/branchReport/GetFrontBackComparisonResData";
import { DownloadBranchReportCommand } from "@/model/communication/branchReport/DownloadBranchReportCommand";
import { mapActions, mapState } from "vuex";
import { RootState } from "@/store";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GET_AVAILABLE_BRANCHES_INCLUDE_DELETED } from "@/store/modules/ApplicationModule/actions";
import { InstallationTypeEnum } from "@/model/data/enums/InstallationTypeEnum";
import { MODULE_COLORS } from "@/utility/Constants";
import { currencies } from "@/utility/Constants";
const selectedCurrency = "CLINK_selected_currency_branch_report";

export default Vue.extend({
    components: {
        BranchReportFiltersCard,
        BranchReportMainSection,
        FrontBackComparisonDetailsCard,
    },
    data() {
        return {
            MODULE_COLORS,
            loading: false,
            downloading: false,
            frontOfficeCashFlowSummaryInstallations: [],
            backOfficeCashFlowSummaryInstallations: [],
            filters: new GetBranchReportReqData(),
            showDetailsModal: false,
            detailsInstallationName: null,
            detailsInstallationType: null,
            detailsLoading: false,
            detailsTransactions: [],
            maxDateRangeDays: 7,
            loadingFilters: false,
            availableCurrencies: currencies,
        };
    },
    computed: {
        ...mapState({
            availableBranches: (state: RootState) => state.application.availableBranchesIncludeDeleted,
        }),

        isDateRangeAllowed() {
            if (
                this.filters != null &&
                this.filters.endDate != null &&
                this.filters.startDate != null &&
                moment(this.filters.endDate).diff(this.filters.startDate, "days") > this.maxDateRangeDays
            )
                return false;
            else return true;
        },
        availableBranchesNames() {
            let availableBranchesNames = [];
            this.availableBranches.forEach((c) => {
                availableBranchesNames.push({ text: c.deleted ? `${c.name} (deleted)` : c.name, value: c.name });
            });
            return availableBranchesNames;
        },
    },
    methods: {
        ...mapActions([GET_AVAILABLE_BRANCHES_INCLUDE_DELETED]),
        async reset() {
            let branchName = null;
            let currency = null;
            if (this.availableBranches && this.availableBranches.length) branchName = this.availableBranches[0].name;
            if (localStorage.getItem(selectedCurrency)) currency = localStorage.getItem(selectedCurrency);
            else currency = this.availableCurrencies.filter((c) => c === "EUR")[0];
            (this.filters as GetBranchReportReqData).reset(branchName, currency);
        },

        async submit() {
            this.loading = true;

            let response: GetBranchReportResData = await new GetBranchReportCommand(this.filters as GetBranchReportReqData).execute();

            if (response.responseStatus == ApiResponseStatusEnum.Success) {
                this.frontOfficeCashFlowSummaryInstallations.splice(0, this.frontOfficeCashFlowSummaryInstallations.length, ...response.frontOfficeCashFlowSummaryInstallations);
                this.backOfficeCashFlowSummaryInstallations.splice(0, this.backOfficeCashFlowSummaryInstallations.length, ...response.backOfficeCashFlowSummaryInstallations);
            }

            this.loading = false;
        },

        async onDetailsClick(name) {
            if (!this.detailsLoading) {
                this.detailsLoading = true;
                this.detailsInstallationName = name;
                this.detailsInstallationType = InstallationTypeEnum.FrontOffice;
                this.showDetailsModal = true;

                let reqData: GetFrontBackComparisonReqData = new GetFrontBackComparisonReqData();
                reqData.installationName = this.detailsInstallationName;
                reqData.startDate = this.filters.startDate;
                reqData.endDate = this.filters.endDate;

                let response: GetFrontBackComparisonResData = await new GetFrontBackComparisonCommand(reqData).execute();
                this.detailsTransactions = response.transactions;

                this.detailsLoading = false;
            }
        },

        onCloseDetailsModal() {
            this.detailsInstallationName = null;
            this.detailsInstallationType = null;
            this.detailsTransactions = [];
            this.showDetailsModal = false;
        },

        async download(exportType: string) {
            console.log("Requested download in ", exportType);
            if (!this.downloading) {
                this.downloading = true;
                try {
                    let lang = this.$i18n.locale;
                    const res = await new DownloadBranchReportCommand(this.filters as GetBranchReportReqData, exportType, lang).execute();

                    let fileURL = window.URL.createObjectURL(new Blob([res.data]));
                    let fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", res.headers["content-disposition"].substring("attachment; filename=".length));
                    document.body.appendChild(fileLink);
                    fileLink.click();
                } catch (e) {
                    console.log("Something went wrong during DownloadBranchReportCommand execution: ", e);
                }
                this.downloading = false;
            }
        },
        async fetchAvailableFilters() {
            this.loading = true;
            this.loadingFilters = true;
            if (!this.availableBranches || !this.availableBranches.length) await this[GET_AVAILABLE_BRANCHES_INCLUDE_DELETED]();
            this.loadingFilters = false;

            this.reset();
            this.loading = false;
        },
    },
    created() {
        this.fetchAvailableFilters();
    },
});
